module.exports = __webpack_public_path__ + "img/solution_round_three.26950695.png";